import Model from "../Model";

class Zones extends Model{

    buildUrl ({ param }) {
        return ['allzoneview/getallzonedata', param];
    }

    all(config = {}) {
        return this.request({ method: 'POST', action: 'all', ...config });
    }
}


export default new Zones;